import { DocumentSelection, DocumentSelectionDto } from "@models/documents/document-selection";
import { DocumentationType, DocumentSelectionType } from "@models/documents/document-enums";

export function getBulkCompanyChangeAddressDocumentSelection(documentationType: DocumentationType): DocumentSelectionDto {
  const selection: DocumentSelection[] = [];

  if (documentationType == DocumentationType.Minutes) {
    selection.push({
      included: true,
      fileId: "c:484:a1:minutes",
      fileName: "Change of Address Minutes",
      documentType: DocumentSelectionType.Minutes,
      mandatory: false,
      sequence: 2
    });
  } else if (documentationType == DocumentationType.Resolution) {
    selection.push({
      included: true,
      fileId: "c:484:a1:resolution",
      fileName: "Change of Address Resolution",
      documentType: DocumentSelectionType.Resolution,
      mandatory: false,
      sequence: 2
    });
  }

  return { selection };
}
